import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'src/gql/api';
// Thunks

export const getContacts = createAsyncThunk(
  'chat/getContacts',
  async (workspaceId) => {
    const response = await api.users.getChatUsers({ workspaceId });

    return response.data?.getChatUsersByWorkspaceId.users ?? [];
  }
);

export const getMembersContacts = createAsyncThunk(
  'chat/getMembersContacts',
  async (situationId) => {
    const response = await api.users.getChatUsersBySituationId({ situationId });

    return response.data?.getChatUsersBySituationId.users ?? [];
  }
);

export const getConversations = createAsyncThunk(
  'chat/getConversations',
  async ({ workspaceId, userId }) => {
    const response = await api.conversations.getConversationsByUserId({
      userId,
      workspaceId,
    });

    return response.data?.getConversationsByWorkspaceId ?? [];
  }
);

export const getConversationById = createAsyncThunk(
  'chat/getConversationById',
  async ({ conversationId, userId }) => {
    const response = await api.conversations.getConversationById({
      conversationId,
      userId,
    });

    return response.data?.getConversationsById;
  }
);

export const getConversationMessages = createAsyncThunk(
  'chat/getConversationMessages',
  async ({ conversationId, skip, take = 10 }) => {
    const result = await api.conversations.getMessagesByConversationId({
      conversationId,
      skip,
      take,
    });

    return result.data?.moreMessageByConversationId ?? [];
  }
);

export const markConversationAsRead = createAsyncThunk(
  'chat/markConversationAsRead',
  async ({ conversationId, userId }) => {
    const result = await api.conversations.markConversationAsRead({
      conversationId,
      userId,
    });

    return result.data;
  }
);

export const syncMessages = createAsyncThunk(
  'chat/syncMessages',
  async ({ conversationId, userId }) => {
    const result = await api.conversations.syncMessagesByConversationId({
      conversationId,
      userId,
    });

    return result.data.syncMessagesByConversationId;
  }
);
